@for (displayVariant of displayVariants; track displayVariant) {
  <li class="autocomplete-list-item"
    [class.-selected]="displayVariant.variant === selectedVariant"
    (mouseover)="selectedVariant = displayVariant.variant"
    (click)="selectVariant(displayVariant.variant)"
    #item>
    <div class="autocomplete-list-item_symbol"
      [innerHTML]="displayVariant.highlightedSecurity.symbol || ''">
    </div>
    @if (displayVariant.highlightedSecurity.exchange) {
      <div class="autocomplete-list-item_exchange"
        [innerHTML]="displayVariant.highlightedSecurity.exchange || ''">
      </div>
    }
  </li>
}

@if (!displayVariants?.length) {
  <li class="autocomplete-list-item">{{'components.autocomplete.nothing_found' | l10n}}</li>
}
